import { useContext } from 'react'
import ModalForm from '../../../components/modal/ModalForm'
import { InputField } from '../../../components/inputs/InputField'
import { TicketsOpModuleContext } from '../context/TicketsOperationContext';
import { useForm } from 'react-hook-form';
import { inputRequiredRule } from '../../../helpers/form.helper';
import { IssueType } from '../../../types';
import FormFragmentTicketText from './FormFragmentTicketText';

export default function FormModalNewTicket() {
    const context = useContext(TicketsOpModuleContext);
    const { control, formState, handleSubmit, reset } = useForm();

    function onSubmit(data: any) {
        let issue: IssueType = {
            description: data.description,
            projectId: context?.target?.dashboardId || '',
            summary: `${data.platform} | ${data.process} | Ver. ${data.version} - ${data.user}`
        };
        context?.sendIssue(issue, data.files);
    }

    return (
        <ModalForm
            open={!!context?.showForm}
            title={{ icon: 'add', label: `Generar ticket` }}
            onCancel={() => context?.setShowForm(false)}
            submitLabel="Agregar"
            onSubmit={handleSubmit(onSubmit)}
            reset={reset}>
            <div className="form-contain-row">
                <div>
                    <InputField
                        variant='standard'
                        controller={{
                            name: "platform",
                            control: control,
                            defaultValue: "",
                            rules: { ...inputRequiredRule },
                        }}
                        errors={formState.errors}
                        label="Modulo operativo*"
                        options={context?.platforms.map(p => ({ label: p.name, value: p.name }))}
                    />
                </div>
                <div>
                    <InputField
                        variant='standard'
                        controller={{
                            name: "process",
                            control: control,
                            defaultValue: "",
                            rules: { ...inputRequiredRule },
                        }}
                        errors={formState.errors}
                        label="Nombre del proceso o servicio*"
                        options={context?.process.map(p => ({ label: p.name, value: p.name }))}
                    />
                </div>
            </div><div className="form-contain-row">
                <div>
                    <InputField
                        variant='standard'
                        controller={{
                            name: "version",
                            control: control,
                            defaultValue: "",
                            rules: { ...inputRequiredRule },
                        }}
                        errors={formState.errors}
                        label="Version*"
                        inputProps={{ maxLength: 10 }}
                    />
                </div>
                <div>
                    <InputField
                        variant='standard'
                        controller={{
                            name: "user",
                            control: control,
                            defaultValue: "",
                            rules: { ...inputRequiredRule },
                        }}
                        errors={formState.errors}
                        label="Usuario*"
                        helpText={'Id del usuario con el que se presento el proceso (Nombre de usuario / CURP / Id empleado).'}
                    />
                </div>
            </div>
            <FormFragmentTicketText formState={formState} control={control} attachmentsRequired />
        </ModalForm>
    )
}
